module.exports = __webpack_public_path__ + "static/media/flower_top@2x.80f49cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift/flower_top@2x.png
// module id = 439
// module chunks = 0